//import { defineCustomElement } from 'vue'

//import AccountSummary from './components/AccountSummary.vue';
//import PageToolbar from './components/PageToolbar.vue';
//import HowIsIt from './components/HowIsIt.vue';
import QueryApp from './components/QueryApp.vue';
import BulkTaskJobPackageEditorWrapper from './components/loadermonitorwrappers/BulkTaskJobPackageEditorWrapper.vue';
//import SignInSignOut from './components/SignInSignOut.vue';
//import WeatherSummaryComponent from './components/WeatherSummary.vue';
//import WeatherSummary2Component from './components/WeatherSummary2.vue';


// Import our custom CSS
import './scss/styles.scss'
import './wxwidgets/wxwidgets.scss'



import { createApp } from 'vue'

//export { createApp, WeatherSummary2Component };

//createApp(WeatherSummary2Component).mount('#app')


let VcComponentLoader = (function(){
    console.log("Starting VcQBComponentLoader..." );
    const COMPONENTS={
        'BulkTaskJobPackageEditor':BulkTaskJobPackageEditorWrapper,
        'QueryApp':QueryApp,
      
        
    };

    window.VcAvailableComponents=(window.VcAvailableComponents && { ...window.VcAvailableComponents, ...COMPONENTS }) || COMPONENTS;

})();



